import { render } from "./ListOrganization.vue?vue&type=template&id=4545e806&scoped=true"
import script from "./ListOrganization.vue?vue&type=script&lang=js"
export * from "./ListOrganization.vue?vue&type=script&lang=js"

import "./ListOrganization.vue?vue&type=style&index=0&id=4545e806&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4545e806"]])

export default __exports__